import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Input from "../common/inputfunction";
import FontAwesome from "react-fontawesome";
import Permitlist from "./renderpermit";
import Monthlist from "./rendermonthselect";
const Billdata = ({
  button1,
  isOpen,
  header,
  onCancel,
  onConfirm,
  message,
  list,
  onDisAprove,
  value,
  onChange,
  year,
  month,
  id,
  error,
  size = "xl",
}) => {
  // const worklist = list.WorkerList;

  //console.log(list.length >0 && list[0]);

  //  console.log(list)
  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={onCancel}
        size={size}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader>
          {list && list.length > 0
            ? "(ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ)"
            : "ยืนยันการโอนเงิน"}
          {"  "}{" "}
          {list && list.length > 0
            ? "บริษัท บีโปรเฟสชั่นนอล"
            : "บริษัท บีโปรเฟสชั่นนอล"}
        </ModalHeader>
        <ModalBody>
          {list && list.length > 0 ? (
            <Permitlist list={list} />
          ) : (
            <Monthlist year={year} month={month} id={id} />
          )}

          {!list && message}
        </ModalBody>
        {error && <div className="col-md-12 alert alert-danger"> {error}</div>}

        {list && list.comment && <Button color="danger">{list.comment}</Button>}
        <ModalFooter>
   

          <Button color="secondary" onClick={onCancel}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Billdata;
